<h3 class="text-primary fw-bold"></h3>
<section>
    <p class="student-privacy-acknowledgement">
        You have acknowledged the Student Privacy Acknowledgment. We thank you.
    </p>

    <div class="school-info">
        <p><b>School state: </b>{{ schoolStateName | async }}</p>
        <p><b>School district: </b>{{ schoolDistrictName }}</p>
        <p><b>School: </b>{{ schoolName }}</p>
    </div>

    <app-data-privacy-support
        (changeSchoolDistrict)="changeSchoolDistrict($event)"
        (changeSchool)="changeSchool($event)"
        (changeSchoolState)="changeSchoolState($event)"
    >
        Need to make a change?
    </app-data-privacy-support>

    <div class="d-flex justify-content-center">
        <button
            type="button"
            class="btn btn-primary fw-bold font-size-14 px-4 py-2 mt-5 gtm-go-to-assignments"
            (click)="router.navigate([navUrl])"
        >
            {{ label }}
        </button>
    </div>
</section>
